module.exports = function(bootstrap) {
	bootstrap.directive('backToTop', ["$window", "smoothFocus", function($window, smoothFocus) {
		return {
			replace: true,
			scope: {},
			link: function(scope, element) {
				scope.hideButton = true;
				scope.backToTop = function() {
					$('html, body').animate({scrollTop: 0}, function() {
						element.find('button').blur();
						smoothFocus.clearTab();
					});
				};
				$(function() {
					$($window).on('scroll', function(data) {
						if ($($window).scrollTop() > 40) {
							if (scope.hideButton !== false) {
								scope.hideButton = false;
								scope.$apply();
							}
						}
						else {
							if (scope.hideButton !== true) {
								scope.hideButton = true;
								scope.$apply();
							}
						}
					});
				});
			},
			template: '<div data-ng-class="{fadeInHidden: hideButton}" class="backToTopButton">'+
						'<button  title="Back To Top" value="Return to page top" data-ng-click="backToTop()">'+
						'<span class="icon-white-single-arrow-up"></span><span class="offscreen textColor">Scroll back to top</span>'+
						'</button>'+
						'</div>'
		}
	}])
	bootstrap.run(["$window", "$compile", "$rootScope", function($window, $compile, $rootScope) {
		angular.element($window.document.body).append('<div data-back-to-top></div>');
	}]);
}